import Model from "../_model";

export default class FeedbackModel extends Model {
	constructor(provider) {
		super(provider, "feedback");
	}

	serialize(feedback) {
		return {
			name: feedback.name,
			email: feedback.email,
			message: feedback.message,
			file: feedback.file
				? {
						key: feedback.file.key,
						type: feedback.file.type,
				  }
				: null,
		};
	}

	create(feedback, { onSuccess, onFail }) {
		const body = this.serialize(feedback);
		return super.create(body, {
			onSuccess,
			onFail,
		});
	}
}
